/* eslint-disable no-param-reassign */
export default {
    getters: {
        getRecord: (state) => (recordType, id) =>
            state.records[recordType] && state.records[recordType][id]
                ? state.records[recordType][id]
                : null,
        getRecords: (state) => (recordType, filterFn) => {
            const records = state.records[recordType] || {};

            return Object.keys(records).reduce((id, curr) => {
                const record = records[id];

                if (typeof filterFn == 'function') {
                    if (filterFn.call(this, record) === true) {
                        curr.push(record);
                    }
                } else {
                    curr.push(record);
                }

                return curr;
            }, []);
        },
        isRecordExist: (state) => (recordType, id) =>
            state.records[recordType] && state.records[recordType][id],
    },
    mutations: {
        regRecord(state, record) {
            const recordType = record.constructor.name;
            const { idProperty } = record.constructor;
            const { records } = state;

            if (!record[idProperty]) {
                return;
            }
            if (!records[recordType]) {
                records[recordType] = {};
            }
            if (!records[recordType][record[idProperty]]) {
                records[recordType][record[idProperty]] = record;
            } else {
                const { fields } = record;
                let fieldName;
                const rec = records[recordType][record[idProperty]];

                for (let i = 0; i < fields.length; i += 1) {
                    if (typeof fields[i] == 'object') {
                        fieldName = fields[i].association
                            ? fields[i].association.name
                            : fields[i].name;
                    } else {
                        fieldName = fields[i];
                    }

                    rec[fieldName] = record[fieldName] || rec[fieldName];
                }
            }
        },
        evict(state, rec) {
            if (
                state.records[rec.constructor.name] &&
                state.records[rec.constructor.name][rec[rec.constructor.idProperty]]
            ) {
                state.records[rec.constructor.name][rec[rec.constructor.idProperty]] = null;
                delete state.records[rec.constructor.name][rec[rec.constructor.idProperty]];
            }
        },
    },
};
/* eslint-enable */
